import { SYSTEM_PAGES } from '@/constants/page';
import { useAuthStore } from '~/store/auth';

export const systemPages = SYSTEM_PAGES;

export const getSystemPageByRoute = (route: string) => {
  return systemPages.find((page) => page.route === route);
}

export const getAllowedPages = (pages: Page[]) => {
  const usuario = useAuthStore().user;
  if (!usuario) return [];

  const permissoes = usuario.tipo ? Object.entries(usuario.tipo).filter(([, v]) => v).map(([k]) => k.toLowerCase()) : [];

  return pages.filter(page => {
    if (!page.require) return true;
    return (!page.require.permissions || permissoes.some(p => page.require?.permissions?.includes(p)));
  });
}

export const getAllowedTabs = (pages: Page[]) => {
  const usuario = useAuthStore().user;
  if (!usuario) return [];

  const permissoes = usuario.tipo ? Object.entries(usuario.tipo).filter(([, v]) => v).map(([k]) => k.toLowerCase()) : [];

  return pages.filter(page => {
    if (!page.require) return true;
    return (!page.require.permissions || permissoes.some(p => page.require?.permissions?.includes(p)));
  }).map(pageToTab);
}

const pageToTab = (page: Page): TabItem => {
  return {
    name: page.title,
    slot: page.slot!,
    route: page.route,
    icon: page.icon,
    color: page.color,
    //@ts-ignore
    require: page.require ?? { modules: [], permissions: [] },
  }
}